/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ArticleSliderItem from 'flarum/orell-articles/components/ArticleSliderItem';

export default function (): void {
	extend(ArticleSliderItem.prototype, 'imageContainerItemList', function (items) {
		const { item: article } = this.attrs;
		if (!article || typeof article.note !== 'function') return;

		const note = article.note();
		if (!note) return;

		items.add(
			'articleNote',
			<div onclick={() => this.showArticleNoteModal()} className="BannerArticleNote-container">
				<span>{app.translator.trans('glowingblue-orell-articles.forum.work.article.see_note')}</span>
			</div>,
			20
		);
	});
}
